import styled from "styled-components";

export const AffiliatePageWithoutProviderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 0 1rem 0;

  .products-cards-affiliation {
    display: flex;

    width: 100%;
    padding: 2rem 0;
    max-width: 81.4375rem;
  }

  @media (max-width: 600px) {
    padding: 0;
  }
`;
